import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const lmColors = {
  brand: '#2BA5A9',
  primary50: '#F9FDFC',
  primary100: '#E5F9F6',
  primary200: '#B9EEE9',
  primary300: '#8FDDD7',
  primary400: '#69CBC8',
  primary500: '#48BABA',
  primary600: '#2BA5A9',
  primary700: '#1C8A92',
  primary800: '#10707B',
  primary900: '#065764',

  secondary50: '#F9FDFC',
  secondary100: '#E5F9F6',
  secondary200: '#B9EEE9',
  secondary300: '#8FDDD7',
  secondary400: '#69CBC8',
  secondary500: '#48BABA',
  secondary600: '#2BA5A9',
  secondary700: '#1C8A92',
  secondary800: '#10707B',
  secondary900: '#065764',
}

export const colorTheme = stylex.createTheme(colors, lmColors)
